var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.553 10.235H5.416c-.324 0-.54-.235-.54-.588V7.294c0-.941.756-1.765 1.621-1.765h12.975c.865 0 1.622.824 1.622 1.765v2.353c0 .235-.217.588-.541.588zM5.957 9.059h14.055V7.294c0-.353-.216-.588-.54-.588H6.497c-.324 0-.54.235-.54.588v1.765z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.31 22H8.66c-1.513 0-2.702-1.294-2.702-2.941V9.647c0-.353.216-.588.54-.588.324 0 .54.235.54.588v9.412c0 .941.758 1.765 1.623 1.765h8.65c.864 0 1.621-.824 1.621-1.765V9.647c0-.353.216-.588.54-.588.325 0 .541.235.541.588v9.412c0 1.647-1.19 2.941-2.703 2.941zM15.687 6.118h-1.08V3.765c0-.353-.217-.589-.541-.589h-2.163c-.324 0-.54.236-.54.589v2.353H10.28V3.765c0-.941.757-1.765 1.622-1.765h2.162c.866 0 1.622.824 1.622 1.765v2.353z",
    fill: "var(--color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.741 18.47c-.324 0-.54-.235-.54-.588v-4.706c0-.353.216-.588.54-.588.325 0 .54.235.54.588v4.706c0 .353-.215.588-.54.588zm3.244 0c-.325 0-.541-.235-.541-.588v-4.706c0-.353.216-.588.54-.588.325 0 .541.235.541.588v4.706c0 .353-.216.588-.54.588zm3.244 0c-.325 0-.541-.235-.541-.588v-4.706c0-.353.216-.588.54-.588.325 0 .541.235.541.588v4.706c0 .353-.216.588-.54.588z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.93a383e0c7629f1aeb6ec33ada9d9381.svg";
export { ForwardRef as ReactComponent };